import {useAppState} from '../appState';

export function useCoreState(): CoreState {
  const {budget, dailyBudget, history, moneyBox, settings} = useAppState();
  return {
    budget,
    dailyBudget,
    history,
    moneyBox,
    settings,
  };
}
